/**
 * RESPONSIBILITY: the frame every band on an event page shares.
 *
 * The heading is here rather than in each band because every theme may carry one and an
 * empty one draws nothing — thirteen copies of that rule is thirteen chances for one of
 * them to render an empty <h2> and leave a gap nobody can find the cause of.
 *
 * The theme's own name goes on the element as a class, so the stylesheet can reach a
 * band by what it IS without the component naming itself twice.
 */
import type { ReactNode } from 'react';
import { slugify } from '../../commons/slug';

export interface FrameProps {
  theme: string;
  heading?: string;
  /** A band that supplies its own background, such as a full-bleed picture. */
  bleed?: boolean;
  children?: ReactNode;
}

export function Band({ theme, heading, bleed = false, children }: FrameProps) {
  return (
    <section className={`ev-band ev-band-${slugify(theme)}${bleed ? ' ev-band-bleed' : ''}`}>
      {heading ? <h2 className="ev-band-head">{heading}</h2> : null}
      {children}
    </section>
  );
}
